export enum StorageTransferStatus {
  IN_DRAFT = "IN_DRAFT",
  CREATED = "CREATED",
  ARCHIVED = "ARCHIVED",
}
